import React from "react";
import "../styles/pages.css";

function GetYourFood() {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h2 className="hero-title">GetYourFood</h2>
        <p className="hero-subtitle">Save Money on Great Food</p>
      </div>
      <div className="coming-soon">
        <h2>Coming Soon</h2>
        <p>We're cooking up something special</p>
      </div>
    </div>
  );
}

export default GetYourFood;
